export const WAEC_CIVIC = [
  {
    q: "A citizen has a duty to:",
    o: ["Evade taxes", "Disobey court orders", "Pay taxes and obey laws", "Ignore elections"],
    a: 2,
    e: "Citizens have civic duties including obeying the law, paying taxes, and participating in civic processes like voting.",
    h: "Rights come with responsibilities.",
    yr: "2023",
  },
  {
    q: "The rule of law means:",
    o: ["The ruler makes all laws", "No one is above the law", "Laws are only for the poor", "The military enforces laws"],
    a: 1,
    e: "The rule of law ensures that all persons, including government officials, are equally subject to the law.",
    h: "Equality before the law.",
    yr: "2022",
  },
  {
    q: "Human rights are:",
    o: ["Privileges granted by government", "Rights that can be easily removed", "Fundamental rights inherent to all humans", "Only for citizens of wealthy nations"],
    a: 2,
    e: "Human rights are universal, inalienable rights that belong to every person by virtue of being human.",
    h: "UDHR — Universal Declaration.",
    yr: "2023",
  },
  {
    q: "INEC in Nigeria is responsible for:",
    o: ["Tax collection", "Conducting elections", "Making laws", "Enforcing court orders"],
    a: 1,
    e: "INEC (Independent National Electoral Commission) organises, manages, and supervises elections in Nigeria.",
    h: "Electoral body.",
    yr: "2021",
  },
  {
    q: "Corruption undermines democracy by:",
    o: ["Promoting transparency", "Diverting public resources for private gain", "Strengthening institutions", "Encouraging civic participation"],
    a: 1,
    e: "Corruption diverts public funds and resources, weakens institutions, and erodes public trust in government.",
    h: "Misuse of public office.",
    yr: "2022",
  },
];

export const WAEC_CIVIC_LEARN = [
  {
    topic: "Rights & Responsibilities",
    content: "Rights: civil (speech, religion, fair trial), political (vote, stand for election), economic (work, fair pay), social (education, health). Responsibilities: obey laws, pay taxes, vote, respect others' rights, protect the environment. Rights and duties are two sides of the same coin.",
  },
  {
    topic: "Democracy & Good Governance",
    content: "Principles of democracy: popular sovereignty, majority rule with minority rights, free and fair elections, rule of law, separation of powers, human rights protection. Good governance adds: accountability, transparency, participation, effectiveness, equity, responsiveness.",
  },
  {
    topic: "Citizenship",
    content: "Ways to acquire citizenship: by birth (jus soli — place of birth; jus sanguinis — parents' nationality), by naturalisation (after residence requirements), by registration (marriage, etc.). Dual citizenship: holding citizenship of two countries. Citizens have rights AND duties.",
  },
  {
    topic: "Anti-Corruption",
    content: "EFCC (Economic and Financial Crimes Commission) — fights financial crimes. ICPC (Independent Corrupt Practices Commission) — tackles corruption in public sector. Transparency International measures corruption globally (CPI). Citizens can fight corruption by: reporting, refusing to bribe, supporting civil society.",
  },
  {
    topic: "Electoral Process in Nigeria",
    content: "INEC registers voters, conducts elections, declares results. Voting is by secret ballot. Election types: presidential, governorship, National Assembly, state assembly, local government. Electoral violence, vote-buying, and rigging undermine democracy. Civil society and media play watchdog roles.",
  },
];
